import { getInventory } from './api/suppliers';
import { alertError } from './alert';

import { setProductFiltersSetFilters, setProductFiltersOrder, setProductFiltersOrderField } from './productFilters';

import {
  SUPPLIER_INVENTORY,
  SUPPLIER_INVENTORY_COUNT,
  SUPPLIER_INVENTORY_SEARCH,
  SUPPLIER_INVENTORY_OFFSET,
  SUPPLIER_INVENTORY_PER_PAGE,
  SUPPLIER_INVENTORY_LOADING_PRODUCTS,
  SUPPLIER_INVENTORY_LOADING,
} from '../constants/supplierInventoryTypes';
import { getTotalCountHeader } from './api/utils';

const setSupplierInventoryLoading = (products, value) => ({
  type: products ? SUPPLIER_INVENTORY_LOADING_PRODUCTS : SUPPLIER_INVENTORY_LOADING,
  payload: value,
});

const setSupplierInventory = (data) => ({ type: SUPPLIER_INVENTORY, payload: data });
const setSupplierInventoryCount = (count) => ({ type: SUPPLIER_INVENTORY_COUNT, payload: count });

export const getSupplierInventory =
  (loadingProducts = true) =>
  async (dispatch, getState) => {
    const state = getState();
    const { supplierId } = state.role;
    const { perPage, offset, count, search } = state.supplierInventory;
    const { currentFilters, order, orderField } = state.productFilters;
    const fields = ['id', 'sku', 'model', 'upc', 'ean', 'title', 'available_inventory', 'last_inventory_update'];

    dispatch(setSupplierInventoryLoading(loadingProducts, true));

    try {
      const response = await getInventory(
        supplierId,
        currentFilters,
        offset,
        perPage,
        search,
        order,
        orderField,
        {},
        fields,
      );

      const newCount = getTotalCountHeader(response);
      if (count !== newCount) {
        dispatch(setSupplierInventoryCount(newCount));
      }

      dispatch(setSupplierInventory(response.data));
    } catch (error) {
      dispatch(alertError(error));
    } finally {
      dispatch(setSupplierInventoryLoading(loadingProducts, false));
    }
  };

export const setSupplierInventorySearch = (search) => (dispatch) => {
  dispatch({ type: SUPPLIER_INVENTORY_SEARCH, payload: search ? search.trim() : null });
  dispatch(setSupplierInventoryOffset(0));
};

export const setSupplierInventoryOffset = (offset) => (dispatch) => {
  dispatch({ type: SUPPLIER_INVENTORY_OFFSET, payload: offset });
  dispatch(getSupplierInventory());
};

export const setSupplierInventoryPerPage = (perPage) => (dispatch) => {
  dispatch({ type: SUPPLIER_INVENTORY_PER_PAGE, payload: perPage });
  dispatch(getSupplierInventory());
};

export const setSupplierInventoryOrderField = (orderField) => (dispatch, getState) => {
  dispatch(setProductFiltersOrderField(orderField));
  dispatch(getSupplierInventory());
};

export const setSupplierInventoryOrder = (order) => (dispatch) => {
  dispatch(setProductFiltersOrder(order));
  dispatch(getSupplierInventory());
};

export const setSupplierInventoryCurrentFilter = (filters) => (dispatch) => {
  dispatch(setProductFiltersSetFilters(filters));
  dispatch(setSupplierInventoryOffset(0));
};
